export enum SourceProjection {
  // Simple 2D Video
  Flat,
  // Alternative, non-2D projection. Informally: "360" Video
  Equirect180,
  Equirect360,
  Cubemap,
  EAC = 4,
}
